import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities/index'
import usePageRouteDetector from 'client/hooks/usePageRouteDetector'
import React from 'react'
import { CommonButtonSettings } from 'src/editor/shared/settings/button/common-button-settings'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { ButtonActionsSettings } from './button-actions-settings'

const ButtonSettingsNew = ({
  entity,
  defaultEntity,
}: SettingsProps<ActionButtonEntityInterface>) => {
  const { isWebsite } = usePageRouteDetector()
  return (
    <>
      {isWebsite && <ButtonTypeGroup entity={entity} />}
      <ButtonActionsSettings entity={entity} />
      <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
    </>
  )
}

export default ButtonSettingsNew
